import type { Order } from "../../../../../../../services";
import type { TFunction } from "i18next";

const cellProcessing = (
	item?: Order.Model["additionalFields"],
	t?: TFunction,
) => {
	const type = item?.transportationType;
	const content = t
		? t([
				`orderPage.order_form.transportation_types.${type}`,
				type ?? "",
		  ]) ?? ""
		: "";
	return { content };
};

export default cellProcessing;
